import ptBR from 'rsuite/lib/IntlProvider/locales/pt_BR';

import { PresetEffectiveDateOption } from './types';

// O rsuite 4 formata o título do calendário com date-fns sem locale, então o mês por extenso sai sempre
// em inglês ("23 Oct, 2026"). Padrões numéricos evitam isso. O `locale` do picker substitui o objeto
// inteiro, por isso os textos pt-BR (dias da semana, "Hoje") são espalhados junto.
export const DATE_PICKER_LOCALE = {
  ...ptBR.Calendar,
  formattedDayPattern: 'DD/MM/YYYY',
  formattedMonthPattern: 'MM/YYYY',
};

// Atalhos no rodapé do calendário. O padrão do rsuite (Hoje/Ontem) usa o relógio do navegador e
// oferece ontem, que não pode ser aplicado.
export const DATE_PICKER_SHORTCUT_OPTIONS: PresetEffectiveDateOption[] = ['TODAY', 'TOMORROW'];
